__turbopack_context__.v({
  "className": "apercunormal_9ba75a6b-module__O1Z-mW__className",
  "variable": "apercunormal_9ba75a6b-module__O1Z-mW__variable",
});
